import $ from 'jquery';
import slick from 'slick-carousel';
import config from '../app-config';

function setSliderDashboard() {
    const boxes = $('.box-dashboard');

    boxes.slick({
        dots: true,
        arrows: false,
        variableWidth: false,
        infinite: false,
        initialSlide: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        edgeFriction: 0,
        speed: 400,
        touchMove: false,
    });
}

function goToNowOnline() {

    $('.box-dashboard').slick('slickGoTo', 0);

    // console.log('goToNowOnline sie wywowalo');
}

function goToTutorials() {

    $('.box-dashboard').slick('slickGoTo', 1);

    // console.log('goToTutorials sie wywowalo');

}

function init() {
    
    if ($('.box-dashboard').length > 0) setSliderDashboard();
    
}

export {init,goToNowOnline,goToTutorials};


// WEBPACK FOOTER //
// ./src/_app/layout/slider-now-online.js